<template>
  <div class="flex flex-col items-center justify-center my-8">
    <img
      src="@/assets/pngs/forgot-password.png"
      alt="forgot-password icon"
      class="w-[180px] h-auto"
    />
    <div class="w-full text-center">
      <h2 class="text-gray-500 text-xl font-normal leading-5 py-6">
        {{ $t('forgotMessage') }}
      </h2>
      <h2 class="text-red-700 text-xl font-normal leading-5 py-2">
        {{ $t('WorningMsg') }}
      </h2>
    </div>
  </div>
</template>

<script>
</script>

<style>
</style>